import type { CountryCode } from "@config/site/types";

export function formatPhoneNumberByCountry(phoneNumber: string, country: CountryCode): string {
    if (country === "JP") {
        const jpRegex = /^(\d{2,3})(\d{4})(\d{4})$/;
        const jpReplacement = "$1-$2-$3";
        return phoneNumber?.replace(jpRegex, jpReplacement);
    }

    return phoneNumber;
}

export function cleanPhoneNumber(phoneNumber: string, country: CountryCode): string {
    if (country.includes("JP") && phoneNumber) {
        // Whitespace as well as hyphens: checkoutV2's step is Formik, which does not write the
        // schema's stripped value back, so the shopper's spacing reaches this point intact.
        return phoneNumber.replace(/[\s-]/g, "");
    }

    // For countries where we can't do a bidirectional transformation, we just remove the non-digit characters.
    return phoneNumber.replace(/[^\d]/g, "");
}

export function removeCountryCodeFromPhoneNumber(phoneNumber: string, countryCode: string): string {
    return phoneNumber.startsWith(countryCode)
        ? phoneNumber.substring(countryCode.length)
        : phoneNumber;
}

export function getLocalPhoneNumber(
    phoneNumber: string,
    countryCode: string,
    country: CountryCode
): string {
    return formatPhoneNumberByCountry(
        removeCountryCodeFromPhoneNumber(phoneNumber, countryCode),
        country
    );
}
